export const applicationSort = [
    { id: 1, name: 'Magic Sort (Relevance)' },
    { id: 2, name: 'Application Date' },
    { id: 3, name: 'Experience: Low to High' },
    { id: 4, name: 'Experience: High to Low' },
]

